import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.alexaI18n.fields.id'),
  },
  {
    name: 'code',
    label: i18n('entities.alexaI18n.fields.code'),
  },
  {
    name: 'text',
    label: i18n('entities.alexaI18n.fields.text'),
  },
  {
    name: 'locale',
    label: i18n('entities.alexaI18n.fields.locale'),
  },
  {
    name: 'version',
    label: i18n('entities.alexaI18n.fields.version'),
  },
  {
    name: 'enterpriseAlexaSkills',
    label: i18n(
      'entities.alexaI18n.fields.enterpriseAlexaSkills',
    ),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.alexaI18n.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.alexaI18n.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
